import DesThumbnail from 'viewmodel/DesThumbnailViewModel';
import { AwHighlightPropertyHtml, DisplayVal } from 'js/hocCollection';
import AwClickableTitle from 'viewmodel/AwClickableTitleViewModel';
const LabelAwHighlightPropertyHtmlDisplayVal = DisplayVal(AwHighlightPropertyHtml('label'));

export const searchResultsCellRenderFunction = (props) => {
    let { item, vmo, accsessionid } = props; //Assume item is ViewModelObject (VMO)

    if (!item) {
        item = vmo;
    }

    if (!item) {
        return null;
    }

    const divStyle = {
        'justify-content': 'center'
    };

    const isTypeProject = item.type === "Project";

    return (
        <div className='aw-default-cell sw-row des-search-cell'>
            <div className='sw-cell-image'>
                <DesThumbnail vmo={item} accsessionid={accsessionid}></DesThumbnail>
            </div>
            <div className='sw-column' style={divStyle}>
                <div className='aw-widgets-cellListCellTitleBlock'>
                    <AwClickableTitle title={item.cellHeader1} cellTitleId='CellTitle' source='list' vmo={item}></AwClickableTitle>
                    {!isTypeProject && <div className='sw-defaultCell-properties'>
                        <label className='sw-property-name'>{item.cellHeader2.key}:</label>
                        <LabelAwHighlightPropertyHtmlDisplayVal className='aw-widgets-propertyValue' title={item.cellHeader2.value}
                            awHighlightPropertyHtml displayVal={item.cellHeader2.value}>{item.cellHeader2.value}
                        </LabelAwHighlightPropertyHtmlDisplayVal>
                    </div>}
                    {!isTypeProject && <div className='sw-defaultCell-properties'>
                        <label className='sw-property-name'>{item.cellHeader3.key}:</label>
                        <LabelAwHighlightPropertyHtmlDisplayVal className='aw-widgets-propertyValue' title={item.cellHeader3.value}
                            awHighlightPropertyHtml displayVal={item.cellHeader3.value}>{item.cellHeader3.value}
                        </LabelAwHighlightPropertyHtmlDisplayVal>
                    </div>}
                </div>
            </div>
        </div>
    );
};
